import React, { useEffect } from 'react'
import { Stack } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import useInterval from '../../utils/Interval/useInterval'
import { useNavigate } from 'react-router-dom'
import { useActionFetchUser } from '../../store/hooks/user/useActionFetchUser'
import { HOME_PATH } from '../../routes/HomeRoutes'

export default function PaymentCallbackPage() {
	const navigate = useNavigate()
	const { subscribed, reload } = useActionFetchUser()

	useInterval(() => {
		reload()
	}, [1000])

	useEffect(() => {
		if (subscribed) {
			navigate(HOME_PATH)
		}
	}, [navigate, subscribed])

	return (
		<Stack justifyContent="center" height="100vh" alignItems="center">
			<CircularProgress />
		</Stack>
	)
}
